export default __webpack_public_path__ + "static/media/088-manta ray.4eec058b.svg";